import { useQuery } from '@tanstack/react-query'
import { SPEND_COUNTRY_GROUP_TRANSLATIONS } from 'api/react-query/keys'
import { getCountryGroupTranslations } from 'SpendControl/endpoints/spend-control'

export const useGetCountryGroupTranslations = ({ countryGroupId }: { countryGroupId: string | undefined }) =>
  useQuery({
    queryKey: [SPEND_COUNTRY_GROUP_TRANSLATIONS, countryGroupId],
    queryFn: () => getCountryGroupTranslations(countryGroupId as string),
    enabled: Boolean(countryGroupId),
  })
